export default {
      id: "icon-logo-signet-usage",
      viewBox: "0 0 248.57 217",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-logo-signet",
      toString: function () {
        return this.url;
      }
    }